import React, { Component } from "react";

import { CButton, CCol, CProgress, CRow, CSelect } from "@coreui/react";
import { Label } from "reactstrap";

import URL from "../../../config/api";
import {
  arrayToCSV,
  elementToPDF,
  arrayToXLSX,
  arrayToXLS
} from "../../../utils/export";

import "./styles.scss";

class estatisticasTurmaAluno extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tipo: "0",
      disciplina: "0",
      professor: "0"
      // infoExport: []
    };
  }

  getArray = data => {
    const header = [
      "aluno",
      "atividades",
      "% conclusão",
      "maior nota",
      "menor nota",
      "média"
    ];
    let x = [];
    const arr = [header];

    const { professor, disciplina, tipo } = this.state;

    const tipos = this.props.room.activities.filter(
      (v, i, a) =>
        a.findIndex(item => item.activity?.type_id === v.activity?.type_id) ===
          i &&
        v.activity?.type_id !== 2 &&
        v.activity?.type_id
    );
    const disciplinas = this.props.room.activities.filter(
      (v, i, a) =>
        a.findIndex(
          item => item.activity?.discipline_id === v.activity?.discipline_id
        ) === i && v.activity?.discipline_id
    );
    const professores = this.props.room.activities.filter(
      (v, i, a) =>
        a.findIndex(item => item.activity?.user_id === v.activity?.user_id) ===
          i && v.activity?.user_id
    );

    this.props?.room?.users
      ?.filter(user => !user.administrator)
      .forEach(user => {
        const activities = this.props.room.activities.filter(
          activity =>
            activity.activity?.type_id !== 2 &&
            activity.users.findIndex(
              activityUser => activityUser.user_id === user.user_id
            ) !== -1 &&
            (!parseInt(tipo) ||
              activity.activity?.type_id === parseInt(tipo)) &&
            (!parseInt(disciplina) ||
              activity.activity?.discipline_id === parseInt(disciplina)) &&
            (!parseInt(professor) ||
              activity.activity?.user_id === parseInt(professor))
        );
        const finished = activities.filter(
          activity =>
            (activity.executions.find(
              activityExecution => activityExecution.user_id === user.user_id
            )?.completion_percentage || 0) >= 100
        );
        const applications = activities
          .filter(
            activity =>
              activity.applications.findIndex(
                activityUser => activityUser.user_id === user.user_id
              ) !== -1
          )
          .map(activity =>
            activity.applications.reduce(
              (a, b) =>
                parseFloat(a.final_grade) > parseFloat(b.final_grade) ||
                b.user_id !== user.user_id
                  ? a
                  : b,
              { id: null, final_grade: "-1.00" }
            )
          );
        const executions = activities
          .filter(
            activity =>
              activity.executions.findIndex(
                activityUser =>
                  activityUser.user_id === user.user_id &&
                  activityUser.grade !== null
              ) !== -1
          )
          .map(activity =>
            activity.executions.reduce(
              (a, b) =>
                parseFloat(a.grade) > parseFloat(b.grade) ||
                b.user_id !== user.user_id
                  ? a
                  : b,
              { id: null, grade: "-1.00" }
            )
          );

        arr.push([
          user.user_name,
          activities.length,
          `${((finished.length / activities.length) * 100).toFixed(2)}%`,
          executions.length > 0
            ? executions
                .reduce((acc, val) => Math.max(acc, parseFloat(val.grade)), 0)
                .toFixed(2)
            : "",
          executions.length > 0
            ? executions
                .reduce(
                  (acc, val) => Math.min(acc, parseFloat(val.grade)),
                  10000
                )
                .toFixed(2)
            : "",
          executions.length > 0
            ? (
                executions.reduce(
                  (acc, val) => acc + parseFloat(val.grade),
                  0
                ) / executions.length
              ).toFixed(2)
            : ""
        ]);
      });
    return arr;
  };

  render() {
    const { professor, disciplina, tipo } = this.state;

    const tipos = this.props.room.activities.filter(
      (v, i, a) =>
        a.findIndex(item => item.activity?.type_id === v.activity?.type_id) ===
          i &&
        v.activity?.type_id !== 2 &&
        v.activity?.type_id
    );
    const disciplinas = this.props.room.activities.filter(
      (v, i, a) =>
        a.findIndex(
          item => item.activity?.discipline_id === v.activity?.discipline_id
        ) === i && v.activity?.discipline_id
    );
    const professores = this.props.room.activities.filter(
      (v, i, a) =>
        a.findIndex(item => item.activity?.user_id === v.activity?.user_id) ===
          i && v.activity?.user_id
    );

    return (
      <div className="layoutTabela flex-column">
        <CRow className="mb-4">
          <CCol>
            <div className="w-100 text-ellipsis">
              <Label className="d-block w-100 text-ellipsis">Tipos</Label>
            </div>
            <CSelect
              value={tipo}
              onChange={e => this.setState({ tipo: e.target.value })}
            >
              <option value={0}>Todos os tipos</option>
              {tipos.map(tipo => (
                <option value={tipo.activity?.type_id}>
                  {tipo.activity?.type_name}
                </option>
              ))}
            </CSelect>
          </CCol>
          <CCol>
            <div className="w-100 text-ellipsis">
              <Label className="d-block w-100 text-ellipsis">Disciplinas</Label>
            </div>
            <CSelect
              value={disciplina}
              onChange={e => this.setState({ disciplina: e.target.value })}
            >
              <option value={0}>Todas as disciplinas</option>
              {disciplinas.map(disciplina => (
                <option value={disciplina.activity?.discipline_id}>
                  {disciplina.activity?.discipline_name}
                </option>
              ))}
            </CSelect>
          </CCol>
          <CCol>
            <div className="w-100 text-ellipsis">
              <Label className="d-block w-100 text-ellipsis">Professores</Label>
            </div>
            <CSelect
              value={professor}
              onChange={e => this.setState({ professor: e.target.value })}
            >
              <option value={0}>Todos os professores</option>
              {professores.map(professor => (
                <option value={professor.activity?.user_id}>
                  {professor.activity?.user_name}
                </option>
              ))}
            </CSelect>
          </CCol>
        </CRow>
        {this.props?.room?.users && (
          <div className="d-flex w-100 justify-content-end mt-3 mt-4 pr-3 est-export-bar">
            <CButton
              id="printBtn"
              color="link"
              className="text-muted p-0"
              size="sm"
              onClick={() =>
                arrayToXLSX(
                  this.getArray(this.props?.room?.users),
                  "Estatísticas da turma por estudante.xlsx"
                )
              }
            >
              <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLSX
            </CButton>
            <span className="mx-2">|</span>
            <CButton
              id="printBtn"
              color="link"
              className="text-muted p-0"
              size="sm"
              onClick={() =>
                arrayToXLS(
                  this.getArray(this.props?.room?.users),
                  "Estatísticas da turma por estudante.xls"
                )
              }
            >
              <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLS
            </CButton>
            <span className="mx-2">|</span>
            <CButton
              id="printBtn"
              color="link"
              className="text-muted p-0"
              size="sm"
              onClick={() =>
                arrayToCSV(
                  this.getArray(this.props?.room?.users),
                  "Estatísticas da turma por estudante.csv"
                )
              }
            >
              <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para CSV
            </CButton>
            <span className="mx-2">|</span>
            <CButton
              id="printBtn"
              color="link"
              className="text-muted p-0"
              size="sm"
              onClick={() =>
                elementToPDF("list", "Estatísticas da turma por estudante.pdf")
              }
            >
              <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para PDF
            </CButton>
          </div>
        )}
        {/* Em tela estreita a tabela rola na horizontal dentro do modal
            (Classroom/Show/styles.css). Antes ficava escondida abaixo de 576px
            (d-none d-sm-table) e o celular não via dado nenhum. */}
        <table className="table table-hover table-outline mb-0" id="list">
          <thead className="thead-light">
            <tr>
              <th></th>
              <th>Estudante</th>
              <th>Atividades</th>
              <th>% Conclusão</th>
              <th>Maior nota</th>
              <th>Menor nota</th>
              <th>Média</th>
            </tr>
          </thead>
          <tbody>
            {this.props?.room?.users
              ?.filter(user => !user.administrator)
              .map(user => {
                const activities = this.props.room.activities.filter(
                  activity =>
                    activity.activity?.type_id !== 2 &&
                    activity.users.findIndex(
                      activityUser => activityUser.user_id === user.user_id
                    ) !== -1 &&
                    (!parseInt(tipo) ||
                      activity.activity?.type_id === parseInt(tipo)) &&
                    (!parseInt(disciplina) ||
                      activity.activity?.discipline_id ===
                        parseInt(disciplina)) &&
                    (!parseInt(professor) ||
                      activity.activity?.user_id === parseInt(professor))
                );
                const finished = activities.filter(
                  activity =>
                    (activity.executions.find(
                      activityExecution =>
                        activityExecution.user_id === user.user_id
                    )?.completion_percentage || 0) >= 100
                );
                const applications = activities
                  .filter(
                    activity =>
                      activity.applications.findIndex(
                        activityUser => activityUser.user_id === user.user_id
                      ) !== -1
                  )
                  .map(activity =>
                    activity.applications.reduce(
                      (a, b) =>
                        parseFloat(a.final_grade) > parseFloat(b.final_grade) ||
                        b.user_id !== user.user_id
                          ? a
                          : b,
                      { id: null, final_grade: "-1.00" }
                    )
                  );
                const executions = activities
                  .filter(
                    activity =>
                      activity.executions.findIndex(
                        activityUser =>
                          activityUser.user_id === user.user_id &&
                          activityUser.grade !== null
                      ) !== -1
                  )
                  .map(activity =>
                    activity.executions.reduce(
                      (a, b) =>
                        parseFloat(a.grade) > parseFloat(b.grade) ||
                        b.user_id !== user.user_id
                          ? a
                          : b,
                      { id: null, grade: "-1.00" }
                    )
                  );

                return (
                  <tr key={user.id}>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="c-avatar mr-3">
                          <img
                            src={
                              // URL.img +
                              // (item.foto || "uploads/users/profileEmpty.jpg")
                              // `https://eitrawmaterials.eu/wp-content/uploads/2016/09/person-icon.png`
                              `${URL.img}${
                                user.user_photo ||
                                "uploads/users/profileEmpty.jpg"
                              }`
                            }
                            className="c-avatar-img"
                            alt="imagem"
                          />
                        </div>
                        {/* {item.nome} */}
                      </div>
                    </td>
                    <td>{user.user_name}</td>
                    <td>{activities.length}</td>
                    <td>
                      <div className="clearfix">
                        <div className="float-left">
                          <strong>
                            {(
                              (finished.length / activities.length) *
                              100
                            ).toFixed(2)}
                            %
                          </strong>
                        </div>
                      </div>
                      <CProgress
                        className="progress-xs"
                        color={
                          ((finished.length / activities.length) * 100).toFixed(
                            2
                          ) > 50
                            ? "success"
                            : (
                                (finished.length / activities.length) *
                                100
                              ).toFixed(2) <= 50 &&
                              (
                                (finished.length / activities.length) *
                                100
                              ).toFixed(2) >= 30
                            ? "warning"
                            : "danger"
                        }
                        value={(
                          (finished.length / activities.length) *
                          100
                        ).toFixed(2)}
                      />
                    </td>

                    <td>
                      {executions.length > 0
                        ? executions
                            .reduce(
                              (acc, val) =>
                                Math.max(acc, parseFloat(val.grade)),
                              0
                            )
                            .toFixed(2)
                        : ""}
                    </td>
                    <td>
                      {executions.length > 0
                        ? executions
                            .reduce(
                              (acc, val) =>
                                Math.min(acc, parseFloat(val.grade)),
                              10000
                            )
                            .toFixed(2)
                        : ""}
                    </td>
                    <td>
                      {executions.length > 0
                        ? (
                            executions.reduce(
                              (acc, val) => acc + parseFloat(val.grade),
                              0
                            ) / executions.length
                          ).toFixed(2)
                        : ""}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default estatisticasTurmaAluno;
